import { useState, useEffect, useRef, Fragment, memo, useContext, useCallback } from "react";
import styleUi from "./EventDetail.module.scss";
import TabList from "../../comm/global/components/TabList";
import MsgBoard from "./MegBoard";
import * as YStyled from '../../Styleds';
import Links from "../../comm/global/components/Links";
import NoticeView from "../../comm/global/components/NoticeView";
import { v4 } from "uuid";
import apiManager from './../../ApiManager';
import { highlightLink } from "../../comm/comm";
import { GameContext } from "../../GameContext";
function getCurrectDate(date, day) {
    let newDate = new Date(date);
    newDate.setDate(newDate.getDate() + day);
    return `${newDate.getMonth() + 1}/${newDate.getDate()}`;
}
const SubMenuAndContent = ({ isSetting, vo, addModalType, participants }) => {
    const { userData } = useContext(GameContext);
    const [tabSelectId, set_tabSelectId] = useState(0);
    const [isMaster, set_isMaster] = useState(false);
    const [isLinksEdit, set_isLinksEdit] = useState(false);
    const [scheduleIndex, set_scheduleIndex] = useState(0);
    const [event_announcement, set_event_announcement] = useState([]);
    const [links, set_links] = useState([]);
    const [scheduleList, set_scheduleList] = useState([]);
    const [msgList, set_msgList] = useState([]);
    const [accountingList, set_accountingList] = useState([]);
    useEffect(() => {
        set_isMaster(userData?.users_id === vo.events_created_by);
    }, [])
    useEffect(() => {
        if (userData) {
            if (tabSelectId === 0) {
                apiManager.fetchGet(`event/${vo.events_id}/announcement`, {}, 0,).then(res => {
                    console.log("res", res)
                    set_event_announcement((res.length === 0) ? [] : res[0].event_announcement);
                })
            }
            else if (tabSelectId === 1) {
                apiManager.fetchGet(`event/${vo.events_id}/reference-links`, {}, 0).then(res => {
                    set_links(res);
                })
            }
            else if (tabSelectId === 2) {
                apiManager.fetchGet(`event/${vo.events_id}/schedule`, {}, 0).then(res => {
                    console.log("res", res)
                    set_scheduleList(res);
                })
            }
            else if (tabSelectId === 3) {
                apiManager.fetchGet(`event/${vo.events_id}/message-board`, {}, 0).then(res => {
                    console.log("res", res)
                    set_msgList(res);
                })
            }
            else if (tabSelectId === 4) {
                apiManager.fetchGet(`event/${vo.events_id}/accounting`, {}, 0).then(res => {
                    console.log("accounting res", res)
                    set_accountingList(res);
                })
            }
        }
    }, [tabSelectId]);
    return (
        <>
            <div className={styleUi.subMenu}>
                <TabList selectId={tabSelectId} set_selectId={set_tabSelectId} list={["重點公告", "參考資訊", "行程表", "留言板", "記帳本"]} ItemCls={MenuItem} clear={false} />
            </div>
            {
                tabSelectId === 0 &&
                <YStyled.Col style={{ background: "white", minHeight: "30rem", padding: "2rem 1rem 1rem 1rem" }}>
                    <NoticeView event_announcement={event_announcement} set_event_announcement={set_event_announcement} isSetting={isSetting} isMaster={isMaster} vo={vo} addModalType={addModalType} />
                </YStyled.Col>
            }
            {
                tabSelectId === 1 &&
                <YStyled.Col style={{ background: "white", minHeight: "30rem", padding: "2rem 1rem 1rem 1rem" }}>
                    <YStyled.Row style={{ marginBottom: "1rem" }}>
                        <YStyled.Span size={17} >參考資訊</YStyled.Span>
                        {isMaster &&
                            <YStyled.Span size={13} fontFamily="SF Pro" fontWeight={400} style={{ cursor: "pointer" }} onClick={e => {
                                set_isLinksEdit(p => !p);
                            }}>{isLinksEdit ? "儲存" : "編輯"}</YStyled.Span>
                        }
                    </YStyled.Row>
                    {userData &&
                        <div className={styleUi.links}>
                            <Links links={links} set_links={set_links} eventsId={vo.events_id} editing={isLinksEdit} addModalType={addModalType} add={isMaster} />
                        </div>
                    }
                </YStyled.Col>
            }
            {
                tabSelectId === 2 &&
                <YStyled.Col style={{ background: "white", minHeight: "30rem", padding: "2rem 1rem 1rem 1rem" }}>
                    <YStyled.Row style={{ marginBottom: "1rem" }}>
                        <YStyled.Span size={17} >行程表</YStyled.Span>
                        {isMaster &&
                            <YStyled.Span size={13} fontFamily="SF Pro" fontWeight={400} style={{ cursor: "pointer" }} onClick={e => {
                                addModalType({
                                    cls: "EditSchedule", arg: {
                                        scheduleVo: scheduleList[scheduleIndex] ?? [],
                                        day: (scheduleIndex + 1),
                                        date: getCurrectDate(vo.events_date, scheduleIndex),
                                        editedCb: scheduleVo => {
                                            let _list = [...scheduleList];
                                            _list[scheduleIndex] = scheduleVo;
                                            _list = _list.map(scheduleVo => {
                                                return scheduleVo.map(v => { return { time: v.time + ":00", description: v.description } })

                                            })
                                            apiManager.fetchPost(`event/${vo.events_id}/schedule`, { schedules: _list }, 0).then(res => {
                                                set_scheduleList(res);
                                            })
                                        }
                                    }
                                })
                            }}>編輯</YStyled.Span>
                        }
                    </YStyled.Row>
                    <STab3 vo={vo} scheduleList={scheduleList} scheduleIndex={scheduleIndex} set_scheduleIndex={set_scheduleIndex} />
                </YStyled.Col>
            }
            {
                tabSelectId === 3 &&

                <YStyled.Col style={{ background: "white", minHeight: "30rem", padding: "2rem 1rem 1rem 1rem" }}>
                    <YStyled.Row style={{ marginBottom: "1rem" }}>
                        <YStyled.Span size={17} >留言板</YStyled.Span>
                    </YStyled.Row>
                    <div className={styleUi.msgBoard}>
                        <MsgBoard msgList={msgList} set_msgList={set_msgList} eventVo={vo} participants={participants} pinCb={(tag, msg) => {
                            console.log(tag, msg, event_announcement);
                            const announcement = event_announcement.find(v => v.event_announcement_category === tag)
                            if (announcement)
                                announcement.event_announcement_message.push(msg);
                            else
                                event_announcement.push({ event_announcement_category: tag, event_announcement_message: [msg] });
                            apiManager.fetchPost(`event/${vo.events_id}/announcement`, event_announcement, 0).then(res => {
                                set_event_announcement(res[0].event_announcement);
                            }).catch(err => {
                                alert(err);
                            })
                            console.log("event_announcement", event_announcement)
                        }} />
                    </div>
                </YStyled.Col>
            }
            {
                tabSelectId === 4 &&

                <STab5 vo={vo} userData={userData} accountingList={accountingList} set_accountingList={set_accountingList} addModalType={addModalType} participants={participants} />
            }
        </>
    );
}

const STab5 = ({ vo, userData, accountingList, set_accountingList, addModalType, participants }) => {
    console.log("participants", participants)
    const [edit, set_edit] = useState(false);
    const [canEdit, set_canEdit] = useState(false);
    useEffect(() => {
        set_canEdit(participants.find(v => v.event_participants_user_detail.user_id === userData.users_id));
    }, [])
    const handletTableData2Change = useCallback((setFn, key, index, value) => {
        setFn(prev => {
            const newTableData = [...prev];
            newTableData[index][key] = value;
            return newTableData;
        });
    }, [accountingList]);
    function getParticipantNameById(id) {
        console.log("id", id)
        const FindObj = participants.find(v => v.event_participants_user === id);
        if (FindObj)
            return FindObj.event_participants_user_detail.user_name;
        else
            return "";
    }

    return (
        <YStyled.Col style={{ background: "white", minHeight: "30rem", padding: "2rem 1rem 1rem 1rem" }}>
            <YStyled.Row style={{ marginBottom: "0rem" }}>
                <YStyled.Span size={17} >記帳本</YStyled.Span>
                {canEdit &&
                    <YStyled.Span size={13} fontFamily="SF Pro" fontWeight={400} style={{ cursor: "pointer" }} onClick={e => {
                        if (edit === true) {
                            const outData = accountingList.reduce((list, acc) => {
                                if (acc.event_accounting_amount && acc.event_accounting_message && acc.event_accounting_paid_by) {
                                    list.push({
                                        event_accounting_amount: parseFloat(acc.event_accounting_amount),
                                        event_accounting_message: acc.event_accounting_message,
                                        event_accounting_paid_by: acc.event_accounting_paid_by,
                                    });
                                }
                                return list;
                            }, []);
                            apiManager.fetchPost(`event/${vo.events_id}/accounting`, outData, 0).then(res => {
                                console.log("reds", res);
                                set_accountingList(res);
                                set_edit(prev => !prev);
                            }).catch(err => {
                                alert(err)
                            })
                        }
                        else
                            set_edit(prev => !prev);
                    }}>{edit ? "完成" : "編輯"}</YStyled.Span>
                }
            </YStyled.Row>
            <div className={styleUi.accountEdit}>
                <table>
                    <tbody>
                        <tr>
                            <td><YStyled.Span size={17} color="#454545">項目</YStyled.Span></td>
                            <td><YStyled.Span size={17} color="#454545">金額</YStyled.Span></td>
                            <td><YStyled.Span size={17} color="#454545">付款人</YStyled.Span></td>
                        </tr>
                        {accountingList.map((v, k) => (
                            <tr key={k}>
                                <td>
                                    {edit ?
                                        <YStyled.Input size={17} color="#454545" placeholder="名稱" value={v.event_accounting_message}
                                            onChange={e => {
                                                console.log("e.target.value", e.target.value);
                                                handletTableData2Change(set_accountingList, "event_accounting_message", k, e.target.value);
                                            }} />
                                        :
                                        <YStyled.Span size={17} fontWeight={400} color="black">{v.event_accounting_message}</YStyled.Span>
                                    }
                                </td>
                                <td>
                                    {edit ?
                                        <YStyled.Input size={17} type="text" inputMode="numeric" color="#454545" placeholder="$" value={v.event_accounting_amount}
                                            onChange={(e) => handletTableData2Change(set_accountingList, "event_accounting_amount", k, e.target.value.replace(/[^0-9.]/g, '').replace(/(\..*?)\..*/g, '$1'))}
                                        /> :
                                        <YStyled.Span size={17} fontWeight={400} color="black">{v.event_accounting_amount}</YStyled.Span>
                                    }
                                </td>
                                <td onClick={e => {
                                    if (edit === false) return;

                                    const _participants = participants.map(v => {
                                        return v.event_participants_user_detail;
                                    })
                                    addModalType({
                                        cls: "OptionSelector", arg: {
                                            type: "option", list: _participants,
                                            displayKey: "user_name",
                                            onSelect: value => {
                                                handletTableData2Change(set_accountingList, "event_accounting_paid_by", k, value.user_id)
                                            }
                                        }
                                    })
                                }}>
                                    {edit ?
                                        <>
                                            {v.name ?
                                                <YStyled.Span size={17} fontWeight={400} color="black">{v.name}</YStyled.Span>
                                                :
                                                <YStyled.Span size={17} fontWeight={400} color="#888">{`${v.event_accounting_paid_by ? getParticipantNameById(v.event_accounting_paid_by) : '請選擇'}`}</YStyled.Span>
                                            }
                                        </> :
                                        <YStyled.Span size={17} fontWeight={400} color="black">{getParticipantNameById(v.event_accounting_paid_by)}</YStyled.Span>
                                    }

                                </td>
                            </tr>
                        ))}
                        
                        {Array.from({ length: Math.max(0, edit?0:(3 - accountingList.length)) }, (_, k) => {
                            return <tr key={k}>
                                <td><YStyled.Span size={17} fontWeight={400} color="#888">Item</YStyled.Span></td>
                                <td><YStyled.Span size={17} fontWeight={400} color="#888">$</YStyled.Span></td>
                                <td><YStyled.Span size={17} fontWeight={400} color="#888">Name</YStyled.Span></td>
                                </tr>
                        })}
                        {edit &&
                            <tr>
                                <td colSpan="3">
                                    <div onClick={e => { set_accountingList(prev => [...prev, []]) }}>
                                        <img src="./assets/ui/add.png" alt="新增" /><span>新增</span>
                                    </div>
                                </td>
                            </tr>
                        }
                    </tbody>
                </table>
            </div>
        </YStyled.Col>);
}
const STab3 = ({ vo, scheduleList, scheduleIndex, set_scheduleIndex }) => {

    return (
        <div className={styleUi.schedule}>
            <div className={styleUi.dateSel}>
                <img src="./assets/ui/arrowLeft.png" onClick={e => {
                    set_scheduleIndex(prev => {
                        if (prev - 1 >= 0)
                            prev--;
                        return prev;
                    })
                }} />
                <YStyled.Span size={17}>{`第${(scheduleIndex + 1).toZH()}天 ・${getCurrectDate(vo.events_date, scheduleIndex)} `}</YStyled.Span>
                <img src="./assets/ui/arrowRight.png" onClick={e => {
                    set_scheduleIndex(prev => {
                        if (prev + 1 < scheduleList.length)
                            prev++;
                        return prev;
                    })
                }} />
            </div>
            <table>
                <tbody>
                    <tr>
                        <td><YStyled.Span size={17}>時間</YStyled.Span></td>
                        <td><YStyled.Span size={17}>行程</YStyled.Span></td>
                    </tr>
                    {scheduleList[scheduleIndex]?.map((v, k) => {
                        const strArr = highlightLink(v.description);
                        console.log("strArr", strArr)
                        return <tr key={v4()}>
                            <td>
                                <YStyled.Span size={17} fontWeight={400}>{v.time}</YStyled.Span>
                            </td>
                            <td>
                                {strArr.map((obj, ind) => (
                                    obj.type === "txt" ? (
                                        <YStyled.Span key={ind} size={17} fontWeight={400}>{obj.content}</YStyled.Span>
                                    ) : (
                                        <a key={ind} href={obj.content} target="_blank" rel="noopener noreferrer">
                                            <YStyled.Span size={17} fontWeight={400}>{obj.content}</YStyled.Span>
                                        </a>
                                    )
                                ))}
                            </td>
                        </tr>
                    })}
                </tbody>
            </table>
        </div>
    );
}
const MenuItem = ({ isSelect, data, index, onClick }) => {
    useEffect(() => {
    }, [])
    return (
        <div onClick={e => { onClick(index) }} className={isSelect ? `${styleUi.item} ${styleUi.selected}` : styleUi.item}>
            <span>{data}</span>
        </div>
    );
}
export default SubMenuAndContent;